import React from 'react';
import UpworkApprovalQueue from './components/UpworkApprovalQueue';
import ProposalWithUpworkReview from './components/ProposalWithUpworkReview';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './components/LoginPage';
import { RegisterPage } from './components/RegisterPage';
import { ForgotPasswordPage } from './components/ForgotPasswordPage';
import { ResetPasswordPage } from './components/ResetPasswordPage';
import { MagicLinkPage } from './components/MagicLinkPage';
import { JobBoard } from './components/JobBoard';
import { MessageBoardPage } from './components/MessageBoardPage';
import { AdminPanel } from './components/AdminPanel';
import { ProtectedRoute } from './components/ProtectedRoute';
import { OnboardingGate } from './components/OnboardingGate';
import { OnboardingFlowPage } from './components/OnboardingFlowPage';
import { OwnerTenantManagementPage } from './components/OwnerTenantManagementPage';
import { LandingPage } from './components/LandingPage';
import { ProposalsList } from './components/ProposalsList';
import Layout from './components/Layout';
import SettingsPage from './components/SettingsPage';
import Dashboard from './components/Dashboard';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import ContactPage from './components/ContactPage';
import ExtensionAuthPage from './components/ExtensionAuthPage';
import OAuthConsentPage from './components/OAuthConsentPage';
import OAuthAuthorizedPage from './components/OAuthAuthorizedPage';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/:tenantSlug/login" element={<LoginPage />} />
        <Route path="/owner/login" element={<Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/:tenantSlug/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/:tenantSlug/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/magic-link/:token" element={<MagicLinkPage />} />
        <Route path="/:tenantSlug/magic-link/:token" element={<MagicLinkPage />} />

        {/* Public registration for invitation-based signups */}
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/:tenantSlug/register" element={<RegisterPage />} />

        {/* Onboarding route - protected but not gated */}
        <Route path="/onboarding" element={
          <ProtectedRoute>
            <OnboardingFlowPage />
          </ProtectedRoute>
        } />

        {/* Protected routes with onboarding gate */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <OnboardingGate>
              <Dashboard />
            </OnboardingGate>
          </ProtectedRoute>
        } />
        <Route path="/jobs" element={
          <ProtectedRoute>
            <OnboardingGate>
              <JobBoard />
            </OnboardingGate>
          </ProtectedRoute>
        } />
        <Route path="/messages" element={
          <ProtectedRoute>
            <OnboardingGate>
              <MessageBoardPage />
            </OnboardingGate>
          </ProtectedRoute>
        } />
        <Route path="/admin/approvals" element={<ProtectedRoute><UpworkApprovalQueue /></ProtectedRoute>} />
        <Route path="/admin/*" element={
          <ProtectedRoute requireAdmin={true}>
            <OnboardingGate>
              <AdminPanel />
            </OnboardingGate>
          </ProtectedRoute>
        } />

        <Route path="/owner/tenants" element={
          <ProtectedRoute>
            <OnboardingGate>
              <OwnerTenantManagementPage />
            </OnboardingGate>
          </ProtectedRoute>
        } />

        {/* Proposal routes */}
        <Route path="/proposals" element={
          <ProtectedRoute>
            <OnboardingGate>
              <ProposalsList />
            </OnboardingGate>
          </ProtectedRoute>
        } />
        <Route path="/proposals/:id" element={
          <ProtectedRoute>
            <OnboardingGate>
              <ProposalWithUpworkReview />
            </OnboardingGate>
          </ProtectedRoute>
        } />

        {/* Settings routes */}
        <Route path="/settings/*" element={
          <ProtectedRoute>
            <OnboardingGate>
              <SettingsPage />
            </OnboardingGate>
          </ProtectedRoute>
        } />

        {/* Profile redirects to settings/profile */}
        <Route path="/profile" element={<Navigate to="/settings/profile" replace />} />

        {/* OAuth consent screen for extension */}
        <Route path="/oauth/authorize" element={<OAuthConsentPage />} />
        <Route path="/oauth/authorized" element={<OAuthAuthorizedPage />} />

        {/* Extension auth callback (legacy) */}
        <Route path="/extension-auth" element={<ExtensionAuthPage />} />

        {/* Public static pages */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Public homepage */}
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
